<template>
  <div>
    <router-link to="/upgrade/pricing" class="cursor-pointer" @click="handleBannerClick">
      <AlertBanner
        :status="1"
        class="banner-below-nav h-40 !leading-10"
        :class="{ 'banner-below-email-verification': offsetForEmailVerificationBanner }"
        :full-page-banner="true"
      >
        <ContentfulText
          content-type="landingPageBanner"
          field-name="promo_banner_post_login_sc_web"
          fallback="Save up to 60% with our value plans"
        />
      </AlertBanner>
    </router-link>
    <!-- adds a spacer to push down main content since the banner is position: fixed -->
    <div class="h-52 md-1:h-56 w-full lg:hidden">&nbsp;</div>
  </div>
</template>

<script lang="ts">
import AlertBanner from '../alert_banner/AlertBanner.vue';
import ContentfulText from '../contentful_text/ContentfulText.vue';
import { sendSegmentEvent } from '../../lib/segment';

export default {
  name: 'ContentfulUpgradeBanner',
  components: {
    AlertBanner,
    ContentfulText,
  },
  props: {
    segmentEventName: {
      type: String,
      required: true,
    },
    offsetForEmailVerificationBanner: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleBannerClick() {
      sendSegmentEvent(this.$props.segmentEventName, {});
    },
  },
};
</script>

<style scoped lang="scss">
/* Stack beneath the persistent email-verification banner when both are visible */
:deep(.banner-below-email-verification) {
  top: calc(48px + 3.5rem);

  @media (min-width: 768px) {
    top: calc(80px + 3.5rem);
  }
}
</style>
